const fonts = {
  TEXT_FONT: 'Lato',
  HEADING_FONT: 'Montserrat',
  fontSizes: {
    h1: '34px',
    h2: '30px',
    h3: '24px',
    h4: '20px',
    h5: '1.125rem',
  
    regular: '1.125rem', //18px
    medium: '1rem', //16px
    small: '0.875rem', //14px
    xSmall: '0.75rem', //12px
  }
}

export default fonts;
